// Typography: the only places a font family, size or weight is chosen. Every string the app shows
// is one of these, so a type change is one edit here and the scale stays a scale.
import "./config";
import { Text, styled } from "tamagui";

export const Body = styled(Text, {
  name: "Body",
  color: "text",
  fontFamily: "body",
  fontSize: "4",
  lineHeight: "4",
  variants: {
    tone: {
      normal: { color: "text" },
      dim: { color: "textDim" },
      faint: { color: "textFaint" },
      accent: { color: "accent" },
      error: { color: "error" },
      ready: { color: "ready" },
      wait: { color: "wait" },
    },
    size: {
      small: { fontSize: "3", lineHeight: "3" },
      body: { fontSize: "4", lineHeight: "4" },
      large: { fontSize: "5", lineHeight: "5" },
    },
    weight: {
      regular: { fontWeight: "400" },
      medium: { fontWeight: "500" },
      strong: { fontWeight: "700" },
    },
    /** Tabular figures, so a column of numbers lines up. */
    numeric: { true: { fontVariant: ["tabular-nums"] } },
    center: { true: { textAlign: "center" } },
    truncate: { true: { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } },
  } as const,
});

export const Caption = styled(Body, {
  name: "Caption",
  render: "span",
  fontSize: "2",
  lineHeight: "2",
  color: "textDim",
});

/** The small uppercase label above a section or a figure. */
export const Eyebrow = styled(Caption, {
  name: "Eyebrow",
  fontSize: "1",
  lineHeight: "1",
  fontWeight: "700",
  textTransform: "uppercase",
  letterSpacing: 1,
  color: "textFaint",
});

const heading = {
  fontFamily: "heading",
  color: "text",
  fontWeight: "500",
} as const;

export const Display = styled(Text, {
  name: "Display",
  render: "h1",
  ...heading,
  fontSize: "8",
  lineHeight: "8",
});
export const Title = styled(Text, {
  name: "Title",
  render: "h2",
  ...heading,
  fontSize: "7",
  lineHeight: "7",
});
export const Heading = styled(Text, {
  name: "Heading",
  render: "h3",
  ...heading,
  fontSize: "6",
  lineHeight: "6",
});
export const Subheading = styled(Text, {
  name: "Subheading",
  render: "h4",
  ...heading,
  fontSize: "5",
  lineHeight: "5",
});
